import React from "react";

const LocationComponent = ({data, location}) => {


    
  return (
    <div>
      <div className="location-component">
        <div className="location-component-main">
          <h2 className="location-component-heading">Pet <span>Grooming Services</span> in Other <span>{location&&location}</span> Locality Near You</h2>
          <div className="location-component-content">

{
    data&&data.map( (e) =>(
        <>
        <h3>{e}</h3>
        </>
    ) )
}

            
          </div>
        </div>
      </div>
    </div>
  );
};

export default LocationComponent;
